import axios from './upstreamAwareAxios';
import { getAuth } from '../providers/AppAuthProvider';
import { baseUrl } from '../providers/AppDataProvider';

async function getAuthHeaders() {
  const { accessToken } = (await getAuth()) || {};
  return {
    Authorization: `Bearer ${accessToken}`,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  };
}

const prefix = `${baseUrl}/group`;

export interface GroupItem {
  id: string;
  name: string;
  createdAt: string;
  memberCount: number;
  permissionCount: number;
}

export interface GroupPage {
  data: GroupItem[];
  total: number;
}

// Not react-admin's getList: it renames `filter` to `query=`, which the BFF's FilterGroupRequest refuses with 400.
export async function listGroups(page: number, size: number): Promise<GroupPage> {
  const headers = await getAuthHeaders();
  const { data } = await axios.get<GroupPage>(prefix, { headers, params: { page, size, isPaginate: true } });
  return { data: data?.data ?? [], total: data?.total ?? 0 };
}

export async function deleteGroup(id: string): Promise<{ id: string; name: string; deleted: boolean }> {
  const headers = await getAuthHeaders();
  const { data } = await axios.delete(`${prefix}/${encodeURIComponent(id)}`, { headers });
  return data;
}
